var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useState } from "react";
import FavoritesBrowserStorageService from "./FavoritesBrowserStorageService";
import { get, create, destroy } from "./FavoritesClient";
export function useFavorites() {
    var _this = this;
    var _a = useState(null), favorites = _a[0], setFavorites = _a[1];
    useEffect(function () {
        getCustomerFavorites().then(setFavorites).catch(console.log);
    }, []);
    var getCustomerIdFromCookie = function () {
        var cid = FavoritesBrowserStorageService.getCustomerId();
        return cid ? Number(cid) : undefined;
    };
    var getCustomerFavorites = function () { return __awaiter(_this, void 0, void 0, function () {
        var customerId, existingFavorites, paginator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    customerId = getCustomerIdFromCookie();
                    if (!customerId) return [3, 2];
                    existingFavorites = FavoritesBrowserStorageService.getFavorites();
                    if (existingFavorites) {
                        return [2, existingFavorites];
                    }
                    return [4, get(customerId)];
                case 1:
                    paginator = _a.sent();
                    if (paginator.data) {
                        FavoritesBrowserStorageService.setFavorites(paginator.data);
                    }
                    return [2, paginator.data];
                case 2: return [2, []];
            }
        });
    }); };
    var addFavorite = useCallback(function (customerId, productId) { return __awaiter(_this, void 0, void 0, function () {
        var newItem_1, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, create(customerId, productId)];
                case 1:
                    newItem_1 = _c.sent();
                    if (newItem_1) {
                        setFavorites(function (prevFavorites) {
                            var newFavoritesList = prevFavorites ? __spreadArray(__spreadArray([], prevFavorites, true), [newItem_1], false) : [newItem_1];
                            FavoritesBrowserStorageService.setFavorites(newFavoritesList);
                            return newFavoritesList;
                        });
                        (_b = (_a = window.ONNIT) === null || _a === void 0 ? void 0 : _a.googleTagManager) === null || _b === void 0 ? void 0 : _b.productFavoriteAdded(newItem_1.product.product_name);
                    }
                    return [3, 3];
                case 2:
                    err_1 = _c.sent();
                    throw err_1;
                case 3: return [2];
            }
        });
    }); }, [favorites]);
    var removeFavorite = useCallback(function (customerId, productId) { return __awaiter(_this, void 0, void 0, function () {
        var match, err_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    match = favorites === null || favorites === void 0 ? void 0 : favorites.find(function (item) { return item.product_id === productId; });
                    if (!match) return [3, 5];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, destroy(customerId, match.customer_favorite_id)];
                case 2:
                    _c.sent();
                    (_b = (_a = window.ONNIT) === null || _a === void 0 ? void 0 : _a.googleTagManager) === null || _b === void 0 ? void 0 : _b.productFavoriteRemoved(match.product.product_name);
                    return [3, 4];
                case 3:
                    err_2 = _c.sent();
                    console.log(err_2);
                    return [3, 4];
                case 4:
                    setFavorites(function (prevFavorites) {
                        var _a;
                        var newFavoritesList = (_a = prevFavorites === null || prevFavorites === void 0 ? void 0 : prevFavorites.filter(function (item) { return item.customer_favorite_id !== match.customer_favorite_id; })) !== null && _a !== void 0 ? _a : [];
                        FavoritesBrowserStorageService.setFavorites(newFavoritesList);
                        return newFavoritesList;
                    });
                    _c.label = 5;
                case 5: return [2];
            }
        });
    }); }, [favorites]);
    var isProductOnFavorites = useCallback(function (productId) {
        var match = favorites === null || favorites === void 0 ? void 0 : favorites.find(function (item) { return item.product_id === productId; });
        return !!match;
    }, [favorites]);
    return {
        favorites: favorites,
        addFavorite: addFavorite,
        removeFavorite: removeFavorite,
        isProductOnFavorites: isProductOnFavorites,
    };
}
//# sourceMappingURL=useFavorites.js.map